// Generated by CoffeeScript 1.12.6
var moment, purchaseOrderEnums, titleCase;

moment = require('moment');

purchaseOrderEnums = require('../purchase_order/enums');

titleCase = function(inputString) {
  return inputString.charAt(0).toUpperCase() + inputString.slice(1);
};

module.exports.titleCase = titleCase;

module.exports.statusLabel = function(status) {
  return titleCase(status);
};

module.exports.dropoffDayLabel = function(dropoffDay) {
  return moment(dropoffDay).format('dddd, MMM D');
};

module.exports.deliveryLabel = function(purchaseOrder) {
  if (purchaseOrder.dropoffWindow === 'third-party-carrier') {
    return (module.exports.dropoffDayLabel(purchaseOrder.dropoffDay)) + " by third-party carrier";
  } else if (purchaseOrder.dropoffWindow === 'backhaul') {
    return "" + (module.exports.dropoffDayLabel(purchaseOrder.dropoffDay));
  } else {
    return (module.exports.dropoffDayLabel(purchaseOrder.dropoffDay)) + " between " + purchaseOrder.dropoffWindow;
  }
};
